import * as types from './types';
import { encodeFilterValues } from '../../helpers/utils';

const fetchPostings = (queryParams = null, updateAfterAction, mergeNewPostings, withoutLoading = false) => {
  return {
    type: types.FETCH_POSTINGS,
    meta: {
      async: true,
      blocking: false,
      api: 'avisos',
      path: '/panel/api/v2/postings',
      query: { ...queryParams, searchParameters: encodeFilterValues(queryParams.searchParameters) },
      method: 'GET',
      updateAfterAction,
      mergeNewPostings,
      withoutLoading
    }
  };
};

const fetchPostingsQualityToExport = (branchId = null) => {
  return {
    type: types.FETCH_POSTINGS_QUALITY_TO_EXPORT,
    meta: {
      async: true,
      blocking: false,
      api: 'avisos',
      path: `/panel/api/v2/postings/getPostingsToExport${branchId ? `?branchId=${branchId}` : ''}`,
      method: 'GET'
    }
  };
};

const resetPostingsQualityToExport = () => ({
  type: types.RESET_POSTINGS_QUALITY_TO_EXPORT
});

const resetPostings = () => ({
  type: types.RESET_POSTINGS
});

const updatePosting = payload => ({
  type: types.UPDATE_POSTING,
  payload
});

const fetchIsComplete = postingId => ({
  type: types.CHECK_DRAFT_IS_COMPLETE,
  meta: {
    async: true,
    blocking: false,
    api: 'avisos',
    path: '/panel/api/v2/posting/completePosting',
    query: { postingId },
    method: 'GET'
  }
});

const fetchVisits = postingId => ({
  type: types.FETCH_VISITS,
  meta: {
    async: true,
    blocking: false,
    api: 'avisos',
    path: '/panel/api/v1/performance/getpostingvisits',
    query: { postingId },
    method: 'GET'
  }
});

const fetchQuality = postingId => ({
  type: types.FETCH_QUALITY,
  meta: {
    async: true,
    blocking: false,
    api: 'avisos',
    path: '/panel/api/v1/performance/getpostingquality',
    query: { postingId },
    method: 'GET'
  }
});

const fetchLeads = postingId => {
  return {
    type: types.FETCH_LEADS,
    meta: {
      async: true,
      blocking: false,
      api: 'avisos',
      path: `/panel/api/v1/performance/getpostingleads`,
      method: 'GET',
      query: { postingId }
    }
  };
};

const removeOnePost = postingId => ({
  type: types.REMOVE_ONE_POST,
  postingId
});

const getDuplicatePostings = () => {
  return {
    type: types.DUPLICATE_POST,
    meta: {
      async: true,
      blocking: false,
      api: 'avisos',
      path: `/panel/api/v1/performance/getduplicatedposting`,
      method: 'GET'
    }
  };
};

const fetchPerformanceStatus = postingId => {
  return {
    type: types.FETCH_PERFORMANCE_STATUS,
    meta: {
      async: true,
      blocking: false,
      api: 'avisos',
      path: `/panel/api/v1/performance/getpostingperformancestatus`,
      method: 'GET',
      query: { postingId }
    }
  };
};

const fetchReports = postingId => {
  return {
    type: types.FETCH_REPORTS,
    meta: {
      async: true,
      blocking: false,
      api: 'avisos',
      path: `/panel/api/v2/postings/report/${postingId}`,
      method: 'GET',
      postingId
    }
  };
};

const checkPosting = (postingId, checked) => {
  return {
    type: types.CHECK_POSTING,
    postingId,
    checked
  };
};

const getSocialAdsReport = postingId => {
  return {
    type: types.GET_SOCIAL_ADS_REPORT,
    meta: {
      async: true,
      blocking: false,
      api: 'avisos',
      path: `/panel/api/v2/social/report/${postingId}`,
      method: 'GET'
    }
  };
};

const checkReport = postingId => ({
  type: types.CHECK_POSTING_REPORT,
  meta: {
    async: true,
    blocking: false,
    api: 'avisos',
    path: `/panel/api/v2/postings/checkReport/${postingId}`,
    method: 'POST'
  }
});

const getPostingViewsStats = postingId => ({
  type: types.POSTING_VIEWS_STATS,
  meta: {
    async: true,
    blocking: false,
    api: 'avisos',
    path: `/panel/api/v2/postings/getpostingviewsstats`,
    method: 'GET',
    postingId,
    query: { postingId }
  }
});

const getPostingLogs = postingId => {
  return {
    type: types.GET_POSTING_LOGS,
    meta: {
      async: true,
      blocking: false,
      api: 'avisos',
      path: `/panel/api/v2/postings/auditory/${postingId}`,
      method: 'GET',
      postingId
    }
  };
};

const fetchDashboardInfo = () => {
  return {
    type: types.GET_DASHBOARD_INFO,
    meta: {
      async: true,
      blocking: false,
      api: 'avisos',
      path: `/panel/api/v2/postings/dashboard/realestate`,
      method: 'GET'
    }
  };
};

// Se hace esta llamada para verificar si la empresa esta desincronizada
const checkOutdatedCompany = (queryParams = null) => {
  return {
    type: types.CHECK_OUTDATED_COMPANY,
    meta: {
      async: true,
      blocking: false,
      api: 'avisos',
      path: `/userInfo/checkOutdatedCompany${queryParams || ''}`,
      method: 'GET'
    }
  };
};

const getFinishReason = publisherTypeId => {
  return {
    type: types.GET_FINISH_REASON,
    meta: {
      async: true,
      blocking: false,
      api: 'avisos',
      path: `/panel/api/v2/postings/finishReason`,
      method: 'GET',
      query: { publisherTypeId }
    }
  };
};

const getFinishReasonByPosting = postingId => {
  return {
    type: types.GET_FINISH_REASON_BY_POSTING,
    meta: {
      async: true,
      blocking: false,
      api: 'avisos',
      path: `/panel/api/v2/postings/finishReasonByPosting`,
      method: 'GET',
      query: { postingId }
    }
  };
};

export {
  fetchPostings,
  fetchPostingsQualityToExport,
  resetPostings,
  updatePosting,
  fetchIsComplete,
  fetchVisits,
  fetchQuality,
  fetchLeads,
  removeOnePost,
  getDuplicatePostings,
  fetchPerformanceStatus,
  checkPosting,
  fetchReports,
  getSocialAdsReport,
  checkReport,
  getPostingViewsStats,
  getPostingLogs,
  fetchDashboardInfo,
  checkOutdatedCompany,
  getFinishReason,
  getFinishReasonByPosting,
  resetPostingsQualityToExport
};
